<script>
import api from "../helper/api";
import db from "../store/persistence/db";

export default {
  data() {
    return {
      imagesLoaded: [],
      getLocalfiles: [],
    };
  },
  async beforeCreate() {
    await db.ready;
    const getLocalfiles = await db.getList("files");
    this.getLocalfiles = getLocalfiles;
  },
  beforeDestroy() {
    this.unloadImages();
  },
  methods: {
    urlById(id) {
      let res = this.getLocalfiles.find((x) => {
        if (x.id == id) {
          return true;
        }
      });
      return res;
    },
    loadImages(images) {
      Object.keys(images).forEach((key) => {
        this.$set(images, key, this.loadImage(images[key]));
      });
    },
    loadImage(image) {
      let imageLoaded = null;

      if (image instanceof Blob) {
        image = { data: image };
      }

      if (image && typeof image == "object") {
        if ("src" in image) {
          return image;
        } else if ("data" in image) {
          this.$set(image, "src", URL.createObjectURL(image.data));

          return image;
        } else if (
          image &&
          typeof image == "object" &&
          "route" in image &&
          (!("src" in image) || !image.src)
        ) {
          this.$set(image, "src", null);
          this.$set(image, "loading", true);
          setTimeout(
            function () {
              const filesDb = this.urlById(image.route);

              if (filesDb && filesDb != undefined && filesDb.value) {
                this.$set(image, "loading", false);
                this.$set(image, "src", URL.createObjectURL(filesDb.value));
                this.imagesLoaded.push(image);
              } else {
                const imageDownloadApiPath =
                  this.config.api.urls.files.download + "/" + image.route;
                ((img) => {
                  api.download(imageDownloadApiPath).then(
                    (url) => {
                      this.$set(img, "loading", false);
                      this.$set(img, "src", url);
                      this.imagesLoaded.push(img);
                    },
                    (err) => {
                      console.log("error loading image", err);
                    }
                  );
                })(image);
              }
            }.bind(this),
            1000
          );

          return image;
        }
      }

      throw new Error("Invalid image data given for loading the image src");
    },
    unloadImages(images = null, removeAfterUnloaded = false) {
      if (!images) {
        images = this.imagesLoaded;
        removeAfterUnloaded = true;
      }

      Object.keys(images).forEach((key) => {
        this.$set(images, key, this.unloadImage(images[key]));

        if (removeAfterUnloaded) {
          this.$delete(images, key);
        }
      });
    },
    unloadImage(image) {
      image = typeof image == "string" ? { src: image } : image;

      if (image && typeof image == "object" && "src" in image) {
        if (typeof image.src == "string" && image.src.indexOf("blob:") === 0) {
          URL.revokeObjectURL(image.src);
        }
        this.$delete(image, "src");
      }

      return image;
    },
  },
};
</script>